import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hasLocale)?_c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c(VIcon,_vm._g({class:'no-locale ' + _vm.additionalClass},on),[_vm._v("warning")])]}}],null,false,3621940104)},[_c('span',[_vm._v(_vm._s(this.$t("global.no_locale", { locale: this.currentLocale.toUpperCase() })))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }